@if (priceIncreaseLoader.data$|async; as wrapper) {
  @if ((!wrapper.object && ('workflow.price.increase.flex'|HasPerm))) {
    <div>
      <workflow-price-increase-flex-empty [workflowId]="workflowId" (update)="reload()">
      </workflow-price-increase-flex-empty>
    </div>
  }
  @if (!!wrapper.object) {
    <div>
      <workflow-price-increase-flex-view [flexPriceIncrease]="wrapper.object" (update)="reload()">
      </workflow-price-increase-flex-view>
    </div>
  }
} @else {
  <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
}

<loading-or-error #loadingOrError
  [loadingWrapper]="priceIncreaseLoader"
  [errorMessage]="'Konnte Flexible Preiserhöhung nicht laden'">
</loading-or-error>
